module.exports = __webpack_public_path__ + "static/media/rotatedTitle.65fe8e5b.png";